module.exports = __webpack_public_path__ + "img/testImage9.aefd67a2.aefd67a2.png";